<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" @click="handleCreate">新增</el-button>

      <el-input class="filter-item" v-model="listQuery.name" placeholder="请输入名称" style="width: 220px;" clearable/>

      <el-input class="filter-item" v-model="listQuery.phone" placeholder="请输入联系电话" style="width: 220px;" clearable/>

      <el-button class="filter-item" type="primary" @click="handleFilter">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="ID" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="学校" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.school ? scope.row.school.school_name : "" }}
        </template>
      </el-table-column>

      <el-table-column label="头像" min-width="110" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.avatar" class="user-avatar">
        </template>
      </el-table-column>

      <el-table-column label="名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>

      <el-table-column label="联系电话" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.phone }}
        </template>
      </el-table-column>

      <el-table-column label="余额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.balance }}
        </template>
      </el-table-column>

      <el-table-column label="可开票金额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.invoice_amount }}
        </template>
      </el-table-column>

      <el-table-column label="每单流入服务费" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_inflow_service_fee }}
        </template>
      </el-table-column>

      <el-table-column label="最大透支金额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.max_overdraft_amount }}
        </template>
      </el-table-column>

      <el-table-column label="最大出餐时长(分钟)" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.max_cooking_time }}
        </template>
      </el-table-column>

      <el-table-column label="最大配送时长(分钟)" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.max_send_time }}
        </template>
      </el-table-column>

      <el-table-column label="最大点达时长(分钟)" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.max_delivery_time }}
        </template>
      </el-table-column>

      <el-table-column label="是否收餐" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_meal === 0" type="danger">否</el-tag>
          <el-tag v-else-if="scope.row.is_meal === 1" type="success">是</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0" type="danger">已冻结</el-tag>
          <el-tag v-else-if="scope.row.status === 1" type="success">正常</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">修改</el-button>

          <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>

          <el-button type="danger" size="mini" @click="handleUpdateStatus(scope.row, 0)" v-if="scope.row.status === 1">冻结</el-button>
          <el-button type="success" size="mini" @click="handleUpdateStatus(scope.row, 1)" v-else>解冻</el-button>

          <el-button type="primary" size="mini" @click="handleBalanceLog(scope.row)">余额明细</el-button>

          <el-button v-if="user.user.type === 'admin'" type="warning" size="mini" @click="handleChargeLedgerEdit(scope.row)">设置充值分账</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30,50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <!-- 详情 -->
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="60%" :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" :model="form" label-width="150px">
        <el-form-item label="用户" prop="user_id" v-if="!form.id">
          <el-select v-model="form.user_id" placeholder="输入昵称/手机号/姓名进行搜索" filterable remote :remote-method="userFilter"  :loading="userFilterLoading" style="width:340px" clearable>
            <el-option v-for="item in users" :key="item.id" :label="item.nickname" :value="item.id">
              <div style="display: flex;align-items:center;text-align:center;">
                <img :src="item.avatar" style="width: 26px;height:26px;border-radius:4px;margin-right:4px;">
                <span>{{ item.nickname }} / {{item.phone}} / {{item.name}}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="名称" prop="name" v-if="!form.id">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item label="联系电话" prop="phone" v-if="!form.id">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>

        <el-form-item label="每单流入服务费" prop="order_inflow_service_fee">
          <el-input-number v-model="form.order_inflow_service_fee" controls-position="right" :precision="2" :min="0"></el-input-number>
        </el-form-item>

        <el-form-item label="最大透支金额" prop="max_overdraft_amount">
          <el-input-number v-model="form.max_overdraft_amount" controls-position="right" :precision="2" :min="0"></el-input-number>
        </el-form-item>

        <el-form-item label="最大出餐时长(分钟)" prop="max_cooking_time">
          <el-input-number v-model="form.max_cooking_time" controls-position="right" :precision="0" :min="0"></el-input-number>
        </el-form-item>

        <el-form-item label="最大配送时长(分钟)" prop="max_send_time">
          <el-input-number v-model="form.max_send_time" controls-position="right" :precision="0" :min="0"></el-input-number>
        </el-form-item>

        <el-form-item label="最大点达时长(分钟)" prop="max_delivery_time">
          <el-input-number v-model="form.max_delivery_time" controls-position="right" :precision="0" :min="0"></el-input-number>
        </el-form-item>

        <el-form-item label="是否收餐" prop="is_meal">
          <el-switch v-model="form.is_meal" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->

    <el-dialog :visible.sync="dialogVisibleChargeLedger" width="50%" :close-on-click-modal="false">
      <el-form ref="chargeLedgerForm" :model="chargeLedgerForm" label-position="right" label-width="150px">
        <div style="font-size:12px;color:red;margin-bottom:20px;">*注意：切换分账类型时，旧分账类型信息需保留，避免以前订单分账失败</div>
        <el-form-item label="分账类型">
          <el-radio-group v-model="chargeLedgerForm.ledger_type">
            <el-radio :label="1">微信分账</el-radio>
<!--            <el-radio :label="3">富友分账</el-radio>-->
          </el-radio-group>
        </el-form-item>

        <template v-if="chargeLedgerForm.ledger_type === 1">
          <el-form-item label="特约商户号">
            <el-input v-model="chargeLedgerForm.sub_mch_id" placeholder="请输入特约商户号" />
          </el-form-item>

          <el-form-item label="微信分账角色">
            <el-checkbox-group v-model="chargeLedgerForm.ledger_role_ids">
              <el-checkbox v-for="item in schoolLedgerRoles" :key="item.id" :label="item.id" :disabled="item.role_type===2">{{item.role_name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleChargeLedger = false">取消</el-button>
        <el-button type="primary" @click="saveDataChargeLedger" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          school_id: "",
          name: "",
          phone: "",
        },
        dialogFormVisible: false,
        dialogStatus: "",
        textMap: {
          update: "修改",
          create: "新增",
        },
        btnLoading: false,
        form:{
          school_id: "",
          user_id: "",
          name: "",
          phone: "",
          order_inflow_service_fee: 0.1,
          max_overdraft_amount: 0,
          max_cooking_time: 30,
          max_send_time: 30,
          max_delivery_time: 30,
          is_meal: 0,
        },
        rules: {
          user_id: [{ required: true, message: "用户不能为空", trigger: "change" }],
          name: [{ required: true, message: "名称不能为空", trigger: "change" }],
          phone: [{ required: true, message: "联系电话不能为空", trigger: "change" }],
          order_inflow_service_fee: [{ required: true, message: "每单流入服务费不能为空", trigger: "change" }],
          max_overdraft_amount: [{ required: true, message: "最大透支金额不能为空", trigger: "change" }],
          max_cooking_time: [{ required: true, message: "最大出餐时长(分钟)不能为空", trigger: "change" }],
          max_send_time: [{ required: true, message: "最大配送时长(分钟)不能为空", trigger: "change" }],
          max_delivery_time: [{ required: true, message: "最大点达时长(分钟)不能为空", trigger: "change" }],
          is_meal: [{ required: true, message: "是否收餐不能为空", trigger: "change" }],
        },
        userFilterLoading: false,
        users: [],
        schoolLedgerRoles: [],
        // 设置充值分账
        dialogVisibleChargeLedger: false,
        chargeLedgerForm: {
          stationmaster_id: "",
          ledger_type: 1,
          sub_mch_id: "",
          ledger_role_ids: [],
        },
      };
    },
    created() {
      this.getList();
      this.getSchoolLedgerRoleList();
    },
    computed: {
      selectedRoleIdLedger () {
        return ledger_role_ids => {
          let ids = this.schoolLedgerRoles.filter(item => item.role_type === 2).map(item => item.id);
          for(let i=0;i<ledger_role_ids.length;i++){
            if (this.schoolLedgerRoles.find((item) => item.id === ledger_role_ids[i]) && !ids.includes(ledger_role_ids[i])) {
              ids.push(ledger_role_ids[i]);
            }
          }
          return ids;
        }
      },
      ...mapGetters(["schools","school_id","user"])
    },
    watch: {
      school_id(newVal, oldVal) {
        this.listQuery.school_id = newVal;
        this.getList();
        this.getSchoolLedgerRoleList();
      },
      dialogVisibleChargeLedger(newVal, oldVal) {
        // 编辑框一异隐藏，马上清除旧数据
        if (newVal === false) {
          this.chargeLedgerForm = {
            stationmaster_id: "",
            ledger_type: 1,
            sub_mch_id: "",
            ledger_role_ids: [],
          };
        }
      },
    },
    methods: {
      getList() {
        this.listQuery.school_id = this.school_id;
        this.listLoading = true;
        request({
          url: "/api/backend/stationmaster/list",
          method: "get",
          params: this.listQuery,
        }).then(response => {
          this.list = response.data.data;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      resetForm() {
        this.form = {
          school_id: "",
          user_id: "",
          name: "",
          phone: "",
          order_inflow_service_fee: 0.1,
          max_overdraft_amount: 0,
          max_cooking_time: 30,
          max_send_time: 30,
          max_delivery_time: 30,
          is_meal: 0,
        }
        this.btnLoading = false;
      },
      handleCreate() {
        this.resetForm()
        this.dialogStatus = "create"
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      handleUpdate(row) {
        this.resetForm()
        this.form = Object.assign({}, row)
        this.dialogStatus = "update"
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      saveData() {
        this.form.school_id = this.school_id;
        if (!this.form.school_id) {
          this.$message({
            type: "warning",
            message: "请先选择学校"
          });
          return;
        }

        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.btnLoading = true;
            request({
              url: "/api/backend/stationmaster/save",
              method: "post",
              data: this.form
            }).then(() => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.getList();
            }).catch(() => {
              this.btnLoading = false;
            });
          }
        });
      },
      handleDelete(row) {
        this.$confirm("确定继续该操作", "提示", {
          type: "warning"
        }).then(() => {
          request({
            url: "/api/backend/stationmaster/delete",
            method: "post",
            data: {id: row.id},
          }).then(() => {
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.getList();
          })
        }).catch((err) => {
          console.log(err)
        });
      },
      // 更新状态
      handleUpdateStatus(row, status) {
        request({
          url: "/api/backend/stationmaster/updateStatus",
          method: "post",
          data: {
            id: row.id,
            status: status
          }
        }).then(()=>{
          this.$message({
            type: "success",
            message: "操作成功"
          });
          this.getList();
        });
      },
      userFilter(val) {
        this.userFilterLoading = true;
        request({
          url: "/api/backend/user/list",
          method: "get",
          params: {
            page: 1,
            limit: 10,
            keyword: val,
          }
        }).then(response => {
          this.users = response.data.data;
        }).finally(()=>{
          this.userFilterLoading = false
        })
      },
      // 余额明细
      handleBalanceLog(row) {
        this.$router.push('/stationmaster/balanceLog?stationmaster_id=' + row.id)
      },
      getSchoolLedgerRoleList() {
        request({
          url: "/api/backend/school/ledgerRoleList",
          method: "get",
          params: {
            page: 1,
            limit: 100000,
            school_id: this.school_id,
            role_type: 2,
            ledger_type: 1,
            is_use: 1,
          }
        }).then(response => {
          this.schoolLedgerRoles = response.data.data;
        });
      },
      // 设置充值分账
      async handleChargeLedgerEdit(item) {
        // 操作密码
        const { password } = await this.$oprationPassword()
        await request({
          url: "/api/backend/school/checkOperationPassword",
          method: "get",
          params: {
            id: item.school_id,
            operation_password: password,
          },
        }).then(() => {

        }).catch(() => {
          return new Promise((resolve, reject) => {
            this.promise = { resolve, reject } // 将resolve 、reject暂存起来,方便调用
          })
        });

        this.chargeLedgerForm = {
          stationmaster_id: item.id,
          ledger_type: item.stationmaster_charge ? item.stationmaster_charge.ledger_type : 1,
          sub_mch_id: item.stationmaster_charge ? item.stationmaster_charge.sub_mch_id : "",
          ledger_role_ids: item.stationmaster_charge ? item.stationmaster_charge.ledger_role_ids : [],
        };
        this.chargeLedgerForm.ledger_role_ids = this.selectedRoleIdLedger(this.chargeLedgerForm.ledger_role_ids);
        this.dialogVisibleChargeLedger = true;
      },
      saveDataChargeLedger() {
        if (this.chargeLedgerForm.ledger_type === 1 && !this.chargeLedgerForm.sub_mch_id) {
          this.$message({
            type: "warning",
            message: "特约商户号不能为空"
          });
          return;
        }

        this.btnLoading = true;
        request({
          url: "/api/backend/stationmaster/chargeLedgerSave",
          method: "post",
          data: this.chargeLedgerForm
        }).then(() => {
          this.dialogVisibleChargeLedger = false;
          this.getList();
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        }).finally(() => {
          this.btnLoading = false;
        });
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 6px;
  }
</style>
